import { render } from "./AssetTypeAddHeader.vue?vue&type=template&id=7bbc30de"
import script from "./AssetTypeAddHeader.vue?vue&type=script&lang=js"
export * from "./AssetTypeAddHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__